export const getData = async (key, apiUrl) => {
    const cookieValue = getCookie(key);

    if (cookieValue) {
        return Promise.resolve(cookieValue);
    } else {
        const response = await fetch(apiUrl);
        const data = await response.json();
        if(data.data.length>0)setCookie(key, JSON.stringify(data), 5);
        return JSON.stringify(data);
    }
}
  
const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
  
const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}